import { Edit, Trash } from 'react-feather';
import { Badge } from 'reactstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from '../../../../api';
import { dispatch } from '../../../../redux';
import { getUsersList } from '../../../../redux/users';
import { Link } from 'react-router-dom';

const ReactSwal = withReactContent(Swal);

const handleConfirmDelete = (email) => {
  return ReactSwal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-outline-danger ms-1'
    },
    buttonsStyling: false,
    showLoaderOnConfirm: true,
    preConfirm() {
      return axios
        .post('api/delete_user', { target: 'delete', key: 'email', value: email })
        .then(() => {
          dispatch(getUsersList());
        })
        .catch((error) => {
          ReactSwal.showValidationMessage(`Request failed:  ${error.response.data}`);
        });
    }
  }).then((result) => {
    if (result.value) {
      ReactSwal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'User has been deleted.',
        customClass: {
          confirmButton: 'btn btn-success'
        }
      });
    }
  });
};

const columns = [
  {
    name: 'User',
    sortable: true,
    minWidth: '100px',
    maxWidth: '250px',
    sortField: 'username',
    selector: (row) => row.username,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <div className="user_name text-truncate text-body">
            <span className="fw-bolder">{row.username}</span>
          </div>
          <small className="text-truncate mb-0">{row.email}</small>
        </div>
      </div>
    )
  },
  {
    name: 'Phone',
    sortable: true,
    minWidth: '100px',
    maxWidth: '200px',
    sortField: 'ph_number',
    selector: (row) => row.ph_number
  },
  {
    name: 'Role',
    minWidth: '13px',
    maxWidth: '190px',
    sortable: true,
    sortField: 'role',
    selector: (row) => row.user_role,
    cell: (row) => (
      <Badge
        className="text-capitalize"
        color={row.user_role === 'admin' ? 'light-primary' : 'light-secondary'}
        pill>
        {row.user_role}
      </Badge>
    )
  },
  {
    name: 'Expiry Date',
    sortable: true,
    minWidth: '100px',
    maxWidth: '180px',
    sortField: 'expiry_date',
    selector: (row) => row.expiry_date
  },
  {
    name: 'number of chars',
    minWidth: '100px',
    maxWidth: '180px',
    sortable: true,
    sortField: 'number_of_chars',
    selector: (row) => row.number_of_chars

  },
  {
    name: 'original number of chars',
    minWidth: '100px',
    maxWidth: '180px',
    sortable: true,
    sortField: 'original_number_of_chars',
    selector: (row) => row.original_number_of_chars

  },
  {
    name: 'Voices',
    minWidth: '100px',
    maxWidth: '250px',
    sortable: true,
    sortField: 'voices',
    allowOverflow: false,
    selector: (row) => row.voices,
    cell: (row) => {
      return (
        <select className="form-select" aria-label="Default select example rounded"
          // if row.voices is empty, disable the select
          disabled={row.voices.length === 0}
        >
          <option
            defaultValue
            className="border bg-light text-muted text-center fw-bolder text-capitalize">
            {row.voices.length} voices
          </option>
          {row.voices.map((voice, i) => (
            <option
              key={i}
              className="border bg-light text-muted text-center fw-bolder text-capitalize"
              disabled
              title={voice.name}>
              {voice.name} / {voice.vendor}
            </ option>
          ))}
        </select>
      )
    }
  },
  {
    name: 'Actions',
    minWidth: '100px',
    maxWidth: '120px',
    allowOverflow: true,
    cell: (row) => {
      return (
        <div>

          <div className="d-flex">
            <div className="me-1">
              <Link
                to={`/admin/edit/${btoa(row.email)}`}
              >
                <Edit size={17} />
              </Link>
            </div>
            <div className="me-1">
              <Trash
                size={17}
                color="#ea5455"
                className="cursor-pointer"
                onClick={() => handleConfirmDelete(row.email)}
              />
            </div>
          </div>
        </div>
      );
    }
  }
];

export default columns;
